<script>
import Component from 'vue-class-component';
import StationShowContentRoute from '@/location/stations/show/StationShowContentRoute';

@Component()
export default class MyStationShowContentRoute extends StationShowContentRoute {}
</script>
